import * as iconSet from "./icon-svg";

export const Icons = iconSet;
